import { Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { CardListItemType } from 'components/card-list/card-list.component';
import { useFormContext } from 'react-hook-form';

type ProductListRemoveIconType = {
  item: CardListItemType;
};

const ProductListRemoveIcon = ({ item }: ProductListRemoveIconType) => {
  const { setValue, getValues } = useFormContext();

  const removeItem = () => {
    setValue(
      'products',
      getValues('products').filter(formItem => formItem.id !== item.id),
    );
  };

  return (
    <IconButton
      aria-label="delete"
      onClick={removeItem}
      data-testid="CardRemove"
    >
      <Close color="error" />
    </IconButton>
  );
};

export default ProductListRemoveIcon;
